/* Harbour & Forge — quick add drawer.
   Any element with [data-hf-quick-add="<product handle>"] opens it. */
(function () {
  if (window.hfQuickAdd) return;

  const SWATCHES = {
    'carbon grey': '#4a4a4a',
    'military green': '#4b5320',
    'charcoal heather': '#4a4d52',
    charcoal: '#36454f',
    'charcoal gray': '#36454f',
    'charcoal grey': '#36454f',
    'aqua blue': '#00b5d8',
    gold: '#d4a017',
    gray: '#808080',
    grey: '#808080',
    'kelly green': '#4cbb17',
    khaki: '#c3b091',
    'light grey': '#d3d3d3',
    'light gray': '#d3d3d3',
    midnight: '#14213d',
    shadow: '#5b5b5b',
    walnut: '#5c4033',
    storm: '#6b7280',
    'navy blue': '#1f2a44',
    'sky blue': '#87ceeb',
    'mild apricot': '#fbdcc4',
    apricot: '#fbceb1',
    coffee: '#6f4e37',
    'oat gray': '#cfc8b8',
    'oat grey': '#cfc8b8',
    'flower gray': '#b8b8b8',
    'flower grey': '#b8b8b8',
    natural: '#e8dcc4',
  };

  const ARROW_PREV =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 8h-11M6.5 4l-4 4 4 4"/></svg>';
  const ARROW_NEXT =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 8h11M9.5 4l4 4-4 4"/></svg>';
  const CLOSE =
    '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>';

  const config = window.hfQuickAddConfig || {};
  const strings = Object.assign(
    { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable', loading: 'Loading', close: 'Close', error: 'Could not add to cart. Please try again.' },
    config.strings || {}
  );
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function formatMoney(cents) {
    const format = config.moneyFormat || '${{amount}}';
    const amount = cents / 100;
    const withDelimiters = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(amount, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(amount, 0, '.', ',');
        default:
          return withDelimiters(amount, 2, ',', '.');
      }
    });
  }

  function swatchColor(value) {
    const key = String(value).split('/')[0].trim().toLowerCase();
    return SWATCHES[key] || key.replace(/[^a-z]/g, '');
  }

  function imageUrl(src, width) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  class Drawer {
    constructor() {
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'hf-qa';
      this.dialog.setAttribute('aria-label', strings.addToCart);
      this.dialog.innerHTML = '<div class="hf-qa__panel"></div>';
      document.body.appendChild(this.dialog);
      this.panel = this.dialog.firstElementChild;

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    open(handle, trigger) {
      this.trigger = trigger;
      this.panel.classList.add('is-loading');
      this.panel.innerHTML =
        '<div class="hf-qa__loading">' + escapeHtml(strings.loading) + '…</div>' + this.closeButton();
      this.bindClose();
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));

      fetch(root + 'products/' + handle + '.js')
        .then((response) => {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then((product) => this.render(product))
        .catch(() => {
          window.location.href = root + 'products/' + handle;
        });
    }

    close() {
      this.dialog.classList.remove('is-open');
      const done = () => {
        if (this.dialog.open) this.dialog.close();
        if (this.trigger && document.contains(this.trigger)) this.trigger.focus({ preventScroll: true });
      };
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) done();
      else setTimeout(done, 400);
    }

    closeButton() {
      return '<button type="button" class="hf-qa__close" aria-label="' + escapeHtml(strings.close) + '">' + CLOSE + '</button>';
    }

    bindClose() {
      const button = this.panel.querySelector('.hf-qa__close');
      if (button) button.addEventListener('click', () => this.close());
    }

    render(product) {
      this.product = product;
      const first = product.variants.find((v) => v.available) || product.variants[0];
      this.selected = product.options.map((option, index) => first['option' + (index + 1)]);
      const hasOptions = !(product.options.length === 1 && product.options[0].values.length === 1 && product.options[0].values[0] === 'Default Title');
      const images = product.images && product.images.length ? product.images.slice(0, 12) : [];

      let html = '';
      html += '<div class="hf-qa__images">';
      html += '<ul class="hf-qa__slides" role="list">';
      images.forEach((src, index) => {
        html +=
          '<li class="hf-qa__slide"><img src="' + escapeHtml(imageUrl(src, 760)) + '" alt="' + escapeHtml(product.title) + '" width="760" height="927" loading="' + (index === 0 ? 'eager' : 'lazy') + '"></li>';
      });
      html += '</ul>';
      if (images.length > 1) {
        html += '<button type="button" class="hf-qa__arrow hf-qa__arrow--prev" aria-label="Previous" disabled>' + ARROW_PREV + '</button>';
        html += '<button type="button" class="hf-qa__arrow hf-qa__arrow--next" aria-label="Next">' + ARROW_NEXT + '</button>';
      }
      html += '</div>';

      html += '<form class="hf-qa__form" novalidate>';
      html += '<h2 class="hf-qa__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h2>';
      html += '<p class="hf-qa__price"></p>';

      if (hasOptions) {
        product.options.forEach((option, index) => {
          const isColor = /^colou?r$/i.test(option.name.trim());
          html += '<fieldset class="hf-qa__option" data-index="' + index + '">';
          html += '<legend class="hf-qa__legend">' + escapeHtml(option.name) + '<small></small></legend>';
          html += '<div class="hf-qa__values' + (isColor ? ' hf-qa__values--swatches' : '') + '">';
          option.values.forEach((value, valueIndex) => {
            const id = 'hf-qa-' + product.id + '-' + index + '-' + valueIndex;
            html += '<span class="hf-qa__value' + (isColor ? ' hf-qa__value--swatch' : '') + '">';
            html += '<input type="radio" name="hf-qa-option-' + index + '" id="' + id + '" value="' + escapeHtml(value) + '"' + (value === this.selected[index] ? ' checked' : '') + '>';
            html += '<label for="' + id + '" title="' + escapeHtml(value) + '"' + (isColor ? ' style="--hf-swatch:' + escapeHtml(swatchColor(value)) + '"' : '') + '>' + escapeHtml(value) + '</label>';
            html += '</span>';
          });
          html += '</div></fieldset>';
        });
      }

      if (product.description) {
        html += '<div class="hf-qa__description rte">' + product.description + '</div>';
      }

      html += '<div class="hf-qa__buttons"><p class="hf-qa__error" role="alert" hidden></p>';
      html += '<button type="submit" class="hf-qa__submit"></button></div>';
      html += '</form>';
      html += this.closeButton();

      this.panel.classList.remove('is-loading');
      this.panel.innerHTML = html;
      this.panel.scrollTop = 0;
      this.bindClose();

      this.form = this.panel.querySelector('.hf-qa__form');
      this.priceEl = this.panel.querySelector('.hf-qa__price');
      this.submit = this.panel.querySelector('.hf-qa__submit');
      this.errorEl = this.panel.querySelector('.hf-qa__error');

      this.form.addEventListener('change', (event) => {
        const fieldset = event.target.closest('.hf-qa__option');
        if (!fieldset) return;
        this.selected[Number(fieldset.dataset.index)] = event.target.value;
        this.update(true);
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.add();
      });

      this.bindSlider();
      this.update(false);
      const close = this.panel.querySelector('.hf-qa__close');
      if (close) close.focus({ preventScroll: true });
    }

    bindSlider() {
      const slides = this.panel.querySelector('.hf-qa__slides');
      const prev = this.panel.querySelector('.hf-qa__arrow--prev');
      const next = this.panel.querySelector('.hf-qa__arrow--next');
      this.slides = slides;
      if (!slides || !prev || !next) return;
      const sync = () => {
        prev.disabled = slides.scrollLeft <= 2;
        next.disabled = slides.scrollLeft >= slides.scrollWidth - slides.clientWidth - 2;
      };
      prev.addEventListener('click', () => slides.scrollBy({ left: -slides.clientWidth, behavior: 'smooth' }));
      next.addEventListener('click', () => slides.scrollBy({ left: slides.clientWidth, behavior: 'smooth' }));
      slides.addEventListener('scroll', sync, { passive: true });
      sync();
    }

    currentVariant() {
      return this.product.variants.find((variant) => this.selected.every((value, index) => variant['option' + (index + 1)] === value));
    }

    update(scrollToImage) {
      const variant = this.currentVariant();

      this.panel.querySelectorAll('.hf-qa__option').forEach((fieldset) => {
        const index = Number(fieldset.dataset.index);
        fieldset.querySelector('small').textContent = this.selected[index];
        fieldset.querySelectorAll('.hf-qa__value').forEach((wrapper) => {
          const value = wrapper.querySelector('input').value;
          const possible = this.product.variants.some(
            (v) => v.available && v['option' + (index + 1)] === value && this.selected.every((sel, i) => i === index || v['option' + (i + 1)] === sel)
          );
          wrapper.classList.toggle('is-unavailable', !possible);
        });
      });

      if (!variant) {
        this.priceEl.textContent = '';
        this.submit.textContent = strings.unavailable;
        this.submit.disabled = true;
        return;
      }

      let price = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        price += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
      }
      price += formatMoney(variant.price);
      this.priceEl.innerHTML = price;

      this.submit.textContent = variant.available ? strings.addToCart : strings.soldOut;
      this.submit.disabled = !variant.available;

      if (scrollToImage && variant.featured_image && this.slides) {
        const clean = (src) => String(src).replace(/^https?:/, '').split('?')[0];
        const target = clean(variant.featured_image.src);
        const index = this.product.images.findIndex((src) => clean(src) === target);
        if (index > -1 && index < this.slides.children.length) {
          this.slides.scrollTo({ left: index * this.slides.clientWidth, behavior: 'smooth' });
        } else {
          // Variant image is outside the rendered slides: show it in the first slide.
          const firstImage = this.slides.querySelector('img');
          if (firstImage) firstImage.src = imageUrl(variant.featured_image.src, 760);
          this.slides.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    add() {
      const variant = this.currentVariant();
      if (!variant || !variant.available || this.submit.disabled) return;

      this.errorEl.hidden = true;
      this.submit.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData();
      body.append('id', variant.id);
      body.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
      }

      const addUrl = (window.routes && window.routes.cart_add_url) || root + 'cart/add';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.errorEl.textContent = response.description || response.message || strings.error;
            this.errorEl.hidden = false;
            this.submit.disabled = false;
            return;
          }
          this.trigger = null;
          this.close();
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            setTimeout(() => cart.renderContents(response), 420);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          }
        })
        .catch(() => {
          this.errorEl.textContent = strings.error;
          this.errorEl.hidden = false;
          this.submit.disabled = false;
        });
    }
  }

  let drawer;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hf-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    if (!drawer) drawer = new Drawer();
    drawer.open(trigger.getAttribute('data-hf-quick-add'), trigger);
  });

  // Paints colour dots on product cards: <span data-hf-swatch="Colour name">
  window.hfPaintSwatches = function (scope) {
    (scope || document).querySelectorAll('[data-hf-swatch]').forEach(function (el) {
      el.style.backgroundColor = swatchColor(el.getAttribute('data-hf-swatch'));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.hfPaintSwatches();
    });
  } else {
    window.hfPaintSwatches();
  }

  window.hfQuickAdd = true;
})();
